import { deleteToken, getToken, setToken } from "../helpers/token-helpers";
import axios from "axios";

export const solicitarToken = async() => {
    try {
        const {data} = await axios.get("https://gw-clientes.mundopacifico.cl/api/sae/token");
        //console.log("banderita", data.success.descripcionRespuesta.token);
        setToken(data.success.descripcionRespuesta.token);
    } catch(error) {
        //console.log(error);
    }
}

